import http from '../../../plugins/axios';

export default {

    componentDisplay(data) {
        return http.post({
            url: '/admin/app/component/display',
            data,
            dataType: 'form'
        })
    },

    componentList() {
        return http.get({
            url: '/admin/app/component/list',
        })
    },

    componentSortNum(data) {
        return http.post({
            url: '/admin/app/component/sortNum',
            data,
            dataType: 'form'
        })
    },

    kingKongCreate(data) {
        return http.post({
            url: '/admin/app/kingKong/create',
            data,
        })
    },

    kingKongDelete(data) {
        return http.post({
            url: '/admin/app/kingKong/delete',
            data,
            dataType: 'form'
        })
    },

    kingKongList(data) {
        return http.get({
            url: '/admin/app/kingKong/list',
            data
        })
    },

    kingKongUpdate(data) {
        return http.post({
            url: '/admin/app/kingKong/update',
            data,
        })
    },

    getCategorys() {
        return http.get({
            url: '/admin/app/kingKong/category',
        })
    },

    //理财配置 ===
financialManageList() {
        return http.get({
            url: '/admin/financialManagementConfig/list'
        })
    },

    financialManageCreate(data) {
        return http.post({
            url: '/admin/financialManagementConfig/create',
            data,
        })
    },

    financialManageUpdate(data) {
        return http.post({
            url: '/admin/financialManagementConfig/update',
            data,
        })
    },

    financialManageDelete(data) {
        return http.post({
            url: '/admin/financialManagementConfig/delete',
            data,
            dataType: 'form'
        })
    },
}
